// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { NavBar } from 'vant';
import { Col, Row } from 'vant';
import { Button } from 'vant';
import { Popup } from 'vant';
import { Form } from 'vant';
import { Field } from 'vant';
import { Picker } from 'vant';
import { DatetimePicker } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Panel } from 'vant';
import { TreeSelect } from 'vant';
import { Overlay } from 'vant';
import { Tab, Tabs } from 'vant';
import { Circle } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Icon } from 'vant';
import { Dialog } from 'vant';
import axios from 'axios'
import VueAxios from 'vue-axios'
import { ImagePreview } from 'vant';

// 全局注册
Vue.use(ImagePreview);
Vue.use(VueAxios,axios);
Vue.use(Dialog);
Vue.use(Icon);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Circle);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Overlay);
Vue.use(TreeSelect);
Vue.use(Panel);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(DatetimePicker);
Vue.use(Picker);
Vue.use(Field);
Vue.use(Form);
Vue.use(Popup);
Vue.use(Button);
Vue.use(Col);
Vue.use(Row);
Vue.config.productionTip = false
Vue.use(NavBar);
Vue.prototype.ROOT = process.env.API_ROOT

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js